const KEY1 = "set:plan";
const KEY2 = "set:month_map";
const KEY3 = "set:user";

const KEY4 = "get:plan";
const KEY5 = "get:plans";
const KEY6 = "get:my_bill";

const KEY7 = "splice:pending_list";
const KEY8 = "set:renew_plan";

const KEY9 = "reset:plan";
const KEY10 = "reset:plans";
const KEY16 = "reset:plan_sale_list";

const KEY11 = "set:albumPostNum";
const KEY12 = "set:album";
const KEY13 = "set:renew_infos_independent";
const KEY14 = "set:plan_sale_list";
const KEY15 = "set:sku_detail";
const KEY17 = "set:limit_show_product_count";
const KEY18 = "set:sale_has_more";
import {
    GET_ORDER_PREPARE,
    GET_CREATOR_PLANS,
    GET_MY_BILL_HISTORY,
} from "../api/config";
import * as $http from "../api/fetch";
import { LIST } from './app'
export const state = () => {
    return {
        plan: null,
        month_map: [],
        user: null,
        plans: [],
        plan_sale_list: [],
        my_bill: null,
        renew_plan: null,
        custom_times: 0,
        albumPostNum: 0,
        album: null,
        renew_infos_independent: [],
        sku_detail: [],
        limit_show_product_count: '',
        sale_has_more:0,
        show_product_count : [
            { value: -1, name: "不限" },
            { value: 1, name: "1" },
            { value: 2, name: "2" },
            { value: 3, name: "3" },
            { value: 4, name: "4" },
            { value: 5, name: "5" },
            { value: 6, name: "6" },
            { value: 7, name: "7" },
            { value: 8, name: "8" },
            { value: 9, name: "9" },
        ],
    };
};

export const mutations = {
    [KEY1](state, val) {
        state.plan = val;
    },
    [KEY2](state, val) {
        state.month_map = val;
    },
    [KEY3](state, val) {
        state.user = val;
    },
    [KEY5](state, val) {
        state.plans = val;
    },
    [KEY6](state, val) {
        state.my_bill = val;
    },
    [KEY7](state, i) {
        state.my_bill.pending_list.splice(i, 1);
    },
    [KEY8](state, val) {
        state.renew_plan = val;
    },
    [KEY9](state, val) {
        state.custom_times = val;
    },
    [KEY11](state, val) {
        state.albumPostNum = val;
    },
    [KEY12](state, val) {
        state.album = val;
    },
    [KEY13](state, val) {
        state.renew_infos_independent = val;
    },
    [KEY14](state, val) {
        state.plan_sale_list = val;
    },
    [KEY15](state, val) {
        state.sku_detail = val;
    },
    [KEY17](state, val) {
      state.limit_show_product_count = val;
    },
    [KEY18](state, val) {
      state.sale_has_more = val;
    },
};

export const actions = {
    // [KEY1]({commit}, plan = null) {
    //     commit(KEY1, plan)
    // },
    // [KEY2]({commit}, month_map = []) {
    //     commit(KEY2, month_map)
    // },
    // [KEY3]({commit}, user = null) {
    //     commit(KEY3, user)
    // },
    async [KEY4]({ commit }, params) {
        if ($http.is_run(GET_ORDER_PREPARE)) {
            return false;
        }
        let data = await $http.$axios(GET_ORDER_PREPARE, params);
        if (data.ec == 200) {
            let d = data.data;
            if (d.plan) {
                commit(KEY1, d.plan);
            } else {
                commit(KEY1, null);
            }
            if (d.month_map) {
                if(LIST.WHITE_LIST.SINGLE_MONTH.indexOf(params.plan_id) != -1){
                    commit(KEY2,  [{name: "1个月", value: 1, discount: 0}]);
                }else{
                    commit(KEY2, d.month_map);
                }
            }
            if (d.sku_detail) {
                commit(KEY15, d.sku_detail);
            }
            commit(KEY3, d.user);
            commit(KEY8, d.renew_info);
        }
        return data;
    },
    async [KEY5]({ commit }, params = {}) {
        try {
            if ($http.is_run(GET_CREATOR_PLANS)) {
                return false;
            }
            let data = await $http.$axios(GET_CREATOR_PLANS, {
                user_id: params.user_id,
                album_id: params.album_id,
                unlock_plan_ids: params.unlock_plan_ids,
            });
            if (data.ec == 200) {
                let d = data.data;
                commit(KEY5, d.list);
                if (d.renew_info) {
                    commit(KEY8, d.renew_info);
                }
                if ("custom_times" in d) {
                    commit(KEY9, d.custom_times);
                }
                if ("albumPostNum" in d) {
                    commit(KEY11, d.albumPostNum);
                }
                if ("album" in d) {
                    commit(KEY12, d.album);
                }
                if ("renew_infos_independent" in d) {
                    commit(KEY13, d.renew_infos_independent);
                }
                if ("sale_list" in d) {
                    commit(KEY14, d.sale_list);
                }
                if ("limit_show_product_count" in d) {
                  commit(KEY17, d.limit_show_product_count);
                }
                if ("sale_has_more" in d) {
                  commit(KEY18, d.sale_has_more);
                }
            }
            // if()
        } catch (e) {
            console.log(`error in ${KEY5}`);
            console.log(e);
        }
    },
    async [KEY6]({ commit }) {
        try {
            if ($http.is_run(GET_MY_BILL_HISTORY)) {
                return false;
            }
            let data = await $http.$axios(GET_MY_BILL_HISTORY);
            if (data.ec == 200) {
                commit(KEY6, data.data);
            }
        } catch (e) {
            console.log(`error in ${KEY6}`);
            console.log(e);
        }
    },
    [KEY7]({ commit }, i) {
        commit(KEY7, i);
    },
    [KEY9]({ commit }, i) {
        commit(KEY1, null);
        commit(KEY2, []);
        commit(KEY3, null);
        commit(KEY8, null);
        commit(KEY15, []);
    },
    [KEY10]({ commit }, i) {
        commit(KEY5, []);
        commit(KEY8, null);
        commit(KEY9, 0);
    },
    [KEY14]({ commit }, i) {
      commit(KEY14, i);
    },
    [KEY16]({ commit }, i) {
      commit(KEY14, []);
    },
    [KEY18]({ commit }, i) {
      commit(KEY18, i);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};